<script setup lang="ts">
import {Section} from "@/types";
import {computed} from "vue";
import {dayjs} from "element-plus";

const props = defineProps<{
  status: number,
  course: Section
}>()

const courseInfo = computed(() => {
  const type = props.course.type === 1 ? `直播课` : props.course.type === 2 ? `录播课` : `其他`
  if (props.course.type === 1) {
    return `${type}，共${props.course.total_section}讲，每讲${props.course.duration}分钟，定价￥${props.course.price}`
  } else if (props.course.type === 2) {
    return `${type}，共${props.course.total_section}讲，定价￥${props.course.price}`
  }
})

const upDownInfo = computed(() => {
  if (props.course.putaway_time && props.course.down_time) {
    return "上架时间" + dayjs(props.course.putaway_time * 1000).format("YY年MM月DD日") + "~" +
    dayjs(props.course.down_time * 1000).format("YY年MM月DD日") + `，购买后有效期为${ props.course.buy_valid_date }`
  }
  return `上下架时间：待定，购买后有效期${ props.course.buy_valid_date }`
})

const emit = defineEmits(['del', 'detail'])

const onDel = () => {
  emit("del", props.course.id)
}

const detail = () => {
  emit("detail", props.course.id)
}
</script>

<template>
  <div class="flex mt-2rem" @click="detail">
    <el-image style="width: 15rem; height: 8.4375rem" :src="course.thumb_image"/>
    <div class="mx-1.5rem flex-1">
      <div class="text-#161616 text-1em">{{ course.title }}</div>
      <div class="text-#939393 text-.75em mt-.875rem">
        {{ courseInfo }}
      </div>
      <div class="text-#939393 text-.75em mt-.875rem">
        {{ upDownInfo }}
      </div>
    </div>
    <div class="my-auto" v-if="status === 2">
      <el-button type="primary" plain @click="onDel">删除</el-button>
    </div>
  </div>
</template>

<style scoped>

</style>